/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import _ from 'lodash';
import { Caption, BoldCaption } from '../Typography';
import { FlexBox } from '../Boxes';
import { translate } from './translate';
import { currentLanguage } from '../../i18n';
import AppContext from '../../AppContext';
import { getProductsByNumber } from '../../selectors';

const deliveryDateValue = (dd) => {
  if (_.isNil(dd)) {
    return null;
  }

  if (_.isNil(dd.label)) {
    return dd.value;
  }

  const parts = dd.label.split('(');

  if (parts.length === 0) {
    return dd.value;
  }

  return parts[0];
};

const deliveryDateContent = (dd) => {
  const v = deliveryDateValue(dd);

  if (v === null) {
    return <></>;
  }

  return (
    <div>
      <b>{translate('deliveryDate')}: </b>
      {v}
    </div>
  );
};

export const ProductSmallDescription = ({ product, deliveryDate }) => {
  const context = React.useContext(AppContext);
  const lang = currentLanguage();

  const getHWGName = React.useCallback(
    (productNumber) => {
      const { hwg } = getProductsByNumber(context)[productNumber];

      if (!hwg) {
        return '?';
      }

      if (!hwg[lang]) {
        return '?';
      }

      return hwg[lang];
    },
    [context, lang]
  );
  return (
    <FlexBox
      marginLeft='sm'
      style={{ minHeight: 150 }}
      justifyContent='space-between'
      flex={1}
      flexDirection='column'
    >
      {product.MaterialInfo__c ? (
        <Caption>{product.MaterialInfo__c}</Caption>
      ) : null}
      <FlexBox flexDirection='column'>
        <BoldCaption>{translate('title')}</BoldCaption>
        {deliveryDateContent(deliveryDate)}
        <div>
          <b>{translate('collection')}: </b>
          {product.collection}
        </div>
        <div>
          <b>{translate('materialNumber')}: </b>
          {product.material}
        </div>
        <div>
          <b>{translate('modelNumber')}: </b>
          {product.number}
        </div>
        <div></div>
        <div>
          <b>{translate('hwg')}: </b>
          {getHWGName(product.number)}
        </div>
        {product.tischOffensiveName && (
          <div>
            <b>{translate('tischOffensive')}: </b>
            {product.tischOffensiveName}
          </div>
        )}
      </FlexBox>
    </FlexBox>
  );
};
